<template>
    <v-dialog persistent v-model ="status" content-class="otp-modal-box" width="365px">
        <div  class="otp-box">
            <v-row>
                <div v-if="otpErrMessage" class="incorrect-otp"><v-icon>mdi-alert-circle</v-icon>{{otpErrMessage}} &nbsp;</div>
                <v-col cols="12" sm="12" class="pad-zero otp-cross">
                    <div class="otp-msg">Please enter the OTP sent to your registered mobile number.</div>
                    <v-icon @click="onClose">mdi-close</v-icon>
                </v-col>
                <v-col cols="12" sm="12" class="pad-zero">
                    <v-otp-input ref="otpInput" input-classes="otp-input" separator="" :num-inputs="5" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange" @on-complete="handleOnComplete"/>
                </v-col>
            </v-row>
        </div>
    </v-dialog>    
</template>
<script>
export default {
    name: 'OTPModal',
      props: ['onClose','status','handleOnComplete','otpErrMessage'],
       
        data(){
            return{
            
            }
        },
        computed: {
           
        },
        methods:{
           
            handleOnChange(value) {
                //console.log('OTP changed: ', value);
            },
            handleClearInput() {
            this.$refs.otpInput.clearInput();
            },
        }
}
</script>